import { createTheme, useTheme } from "@mui/material";
import { isMobile } from "react-device-detect";

export const useSliderThemeHooks = () => {
  const defaultTheme = useTheme();

  const sliderTheme = createTheme({
    components: {
      MuiSlider: {
        styleOverrides: {
          thumb: {
            width: "24px",
            height: "24px",
            boxShadow: "0 3px 6px rgba(0, 0, 0, 0.2)",
            border: "4px solid black",
            backgroundColor: "white"
          },

          rail: {
            border: "4px solid #ededed"
          },

          track: {
            border: "4px solid rgb(255, 240, 0)",
            boxShadow: "0 3px 6px rgba(0, 0, 0, 0.2)"
          },

          mark: {
            color: "#aaaaaa",
            width: "3px",
            height: "3px",
            borderRadius: "1.5px"
          },

          markLabel: {
            fontFamily: "din-2014, zen-maru-gothic, sans-serif",
            opacity: 0.8,
            color: "rgba(125, 125, 125, 1)",
            fontSize: "0.75rem",
            fontWeight: "400",
            letterSpacing: "0.05em"
          },

          markActive: {
            backgroundColor: "#a49b0a",
            width: "3px",
            height: "3px",
            borderRadius: "1.5px"
          },

          valueLabel: {
            fontFamily: "din-2014, zen-maru-gothic, sans-serif",
            fontWeight: "700",
            padding: "0.35em 0.5em 0.3em",
            lineHeight: 1,
            color: "white",
            backgroundColor: "black",
            borderRadius: "6px"
          }
        }
      }
    }
  });

  const mobileSliderTheme = createTheme({
    ...defaultTheme,
    ...(isMobile
      ? {
          components: {
            MuiSlider: {
              styleOverrides: {
                rail: { height: 16, opacity: 0.2 },
                track: { height: 16, opacity: 0.8 },
                thumb: {
                  height: 32,
                  width: 32,
                  borderColor: "white",
                  borderWidth: 2,
                  borderStyle: "solid"
                }
              }
            }
          }
        }
      : {
          components: {
            MuiSlider: {
              styleOverrides: {
                markLabel: { fontSize: 11 }
              }
            }
          }
        })
  });

  return { sliderTheme, mobileSliderTheme } as const;
};
